<template>
    <div>
        <div class="page_footer">
          <div class="container_box">
            <el-row>
              <!-- <el-col :sm="8" :xs="24">
                <img src="../assets/images/Logo.png" class="icon icon_foot" @click="goHome" />
                <div class="copyright">
                  <div>一般社団法人国際教育支援機構</div>
                  <div>Copyright (C)  IESO All Rights Reserved.</div>
                </div>
              </el-col> -->
              <el-col :sm="24" :xs="24">
                <div class="nav_foot" style="text-align:center" v-if="accountType!=1&&accountType2!=1">
                  <span @click="goHome">首页</span>&nbsp;&nbsp;|&nbsp;
                  <span @click="goTeam">师资团队</span>&nbsp;&nbsp;|&nbsp;
                  <span @click="goCourse">公益板块</span>&nbsp;&nbsp;|&nbsp;
                  <span @click="goLearn">公益心声</span>&nbsp;&nbsp;|&nbsp;
                  <!-- <span @click="goAbout">关于IESO</span>&nbsp;&nbsp;|&nbsp; -->
                  <span @click="goNewsList">新闻资讯</span>
                  <!-- <span @click="goPersonInfo">隐私政策</span> -->
                </div>
                <div class="record_box"><span style="margin-right:10px;">指导单位：山东省青年志愿者协会</span> 备案号：<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">鲁ICP备2024116671号-1
                </a></div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="page_common_right">
          <div class="right_box" @mouseleave="imgShow=false" @mouseenter="imgShow=true">
              <img class="ewm" src="../assets/images/icon-wechat.png" alt="">
              微信公众号
              <div class="img_box" v-show="imgShow">
                <img src="../assets/images/gzh-new.jpg">
              </div>
          </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {
      imgShow:false
    }
  },
  methods: {
    //首页
    goHome() {
      this.$router.push({ path: '/' })
      this.isShow = false
    },
    //师资团队
    goTeam() {
      this.$router.push({ path: '/team' })
      this.isShow = false
    },
    //公益板块
    goCourse() {
      this.$router.push({ path: '/course' })
      this.isShow = false
    },
    //公益心声
    goLearn() {
      this.$router.push({ path: '/learn' })
      this.isShow = false
    },
    goNewsList(){
      this.$router.push({path:'/newslist'})
      this.isShow = false
    },
    //关于我们
    goAbout(){
      this.$router.push({path:'/about-us'})
      this.isShow = false
    },
    //个人信息保护方针
    goPersonInfo(){
      this.$router.push({path:'/personal-info'})
      this.isShow = false
    },
    //登录页
    toLogin() {
      this.isShow = false
      this.$router.push({ path: '/logreg/login' })
    },
    //注册页
    toRegister() {
      this.isShow = false
      this.$router.push({ path: '/logreg/register' })
    },
    //教师退出
    getQuitTeacher() {
      localStorage.removeItem('teacherType')
      this.$router.push({ path: '/' })
      this.$router.go(0)
    }
  },
  computed: {
    ...mapState({
      accountType: state => state.user.accountType,
      accountType2: state => state.teacher.accountType,
    })
  },
  mounted() {
  },
  created() {
  },
}
</script>

